import React, { memo } from 'react';
import Editor from '@monaco-editor/react';
import { getMonacoLanguage } from '@/components/pages/education/trainings/utils/getMonacoLanguage';
import { READ_ONLY_EDITOR_OPTIONS, EDITABLE_EDITOR_OPTIONS } from '../utils';
import NotionViewer from './NotionViewer';

/**
 * 파일 콘텐츠 뷰어 - README.md는 NotionViewer, 그 외는 Monaco Editor
 */
const ProjectCodeViewer = memo(({
  fileName,
  content,
  showNotionViewer = false,
  readOnly = true,
  onChange,
}) => {
  const isReadme = showNotionViewer && fileName === 'README.md';
  const normalizedContent = content ?? '';

  if (isReadme) {
    return <NotionViewer content={normalizedContent} />;
  }

  return (
    <Editor
      key={fileName}
      height="100%"
      language={getMonacoLanguage(fileName)}
      theme="vs-light"
      defaultValue={normalizedContent}
      onChange={onChange}
      options={readOnly ? READ_ONLY_EDITOR_OPTIONS : EDITABLE_EDITOR_OPTIONS}
    />
  );
});

ProjectCodeViewer.displayName = 'ProjectCodeViewer';

export default ProjectCodeViewer;
